import $ from "jquery";
import {createApp} from "vue";
import App from "./editorJs/app.vue";
$(() => {
    $('.js-editor-js').each((_, element) => {
        const data = $(element).attr('data');
        const app = createApp(App, {data: JSON.parse(data)});
        const id = $(element).attr('id');
        app.mount(document.getElementById(id));
    });
});
